<!-- Table section -->
<div class="w-full overflow-auto relative">
  <table class="min-w-full">
    @if (showHeader) {
      <thead [style.height]="headerHeight ? headerHeight + 'rem' : 'auto'">
        @if (agrupation) {
          <tr>
            @for (group of groupedHeaders; track $index) {
              <th [attr.colspan]="group.colspan"
                  [class.border-b-1]="!!groups?.[group.slug]"
                  class="px-4 py-2 text-center cd-text-n h-[2.75rem]"
                  style="border-color: var(--color-neutral-300)">
                {{ groups?.[group.slug] ? groups?.[group.slug] : '' }}
              </th>
            }
          </tr>
        }
      <tr>
        @for (header of headers; track header.label + (header.slug || '') + (header.field || '') + (header.group || '')) {
          <th
            [class.text-center]="header?.options?.align === 'center'"
            [class.text-left]="!header?.options?.align || header?.options?.align === 'left'"
            [class.text-right]="header?.options?.align === 'right'"
            class="cd-text-n h-[2.75rem] border-b-1 px-2 tracking-wider"
            style="border-color: var(--color-neutral-300)">
            {{ header.label }}
          </th>
        }
      </tr>
      </thead>
    }
    <tbody>
      @if (data.length) {
        @for (item of data; track item; let i = $index) {
          <tr (click)="toggleRow(item)" [class.cursor-pointer]="expandableTemplate" class="hoverable">
            @for (column of headers; track column.label + (column.slug || '') + (column.field || '') + (column.group || '')) {
              <td
                [class.text-center]="column?.options?.align === 'center'"
                [class.text-left]="!column?.options?.align || column?.options?.align === 'left'"
                [class.text-right]="column?.options?.align === 'right'"
                [style.vertical-align]="column?.options?.verticalAlign || 'top'"
                class="cd-text-md h-[2.75rem] border-b-1 px-2 py-2"
                style="border-color: var(--color-neutral-200)">
                @if (column.customTemplate) {
                  <ng-container
                    *ngTemplateOutlet="column.customTemplate; context: { $implicit: item, index: i }"></ng-container>
                } @else if (column.field) {
                  {{ getFieldValue(item, column.field) }}
                }
              </td>
            }
          </tr>
          @if (expandableTemplate) {
            <tr class="overflow-hidden">
              <td [attr.colspan]="headers.length" class="p-0 border-0">
                <div
                  [@detailExpand]="expandedElement === item ? 'expanded' : 'collapsed'"
                  class="overflow-hidden">
                  <ng-container
                    *ngTemplateOutlet="expandableTemplate; context: { $implicit: item, index: i }"></ng-container>
                </div>
              </td>
            </tr>
          }
        }
      } @else if (!loading) {
        <tr>
          <td class="px-6 py-4 whitespace-nowrap text-center" colspan="100%">
            <p class="cd-text-lg">No hay datos disponibles</p>
          </td>
        </tr>
      }
    </tbody>
  </table>

  @if (loading) {
    <div class="absolute top-0 left-0 w-full h-full bg-neutral-a30 rounded-lg flex justify-center">
      <core-spinner class="w-5 my-auto"/>
    </div>
  }
</div>

@if (paginationEnabled) {
  <div class="sm:hidden p-4 mt-2 bg-neutral-100 rounded-3xl flex justify-between items-center">
    <button (click)="prevPage()"
            [class.opacity-50]="currentPage === 1"
            [disabled]="currentPage === 1"
            class="btn btn-neutral-outline w-[2.25rem] aspect-square inline-flex items-center justify-center mr-[2.5rem]"
            style="padding: 0 !important;">
      <img alt="chevron-left" class="filter-neutral-800" src="/assets/icons/feather/chevron-left.svg">
    </button>

    <button (click)="nextPage()"
            [class.opacity-50]="currentPage === pages"
            [disabled]="currentPage === pages"
            class="btn btn-neutral-outline w-[2.25rem] aspect-square inline-flex items-center justify-center ml-[2.5rem]"
            style="padding: 0 !important;">
      <img alt="chevron-left" class="filter-neutral-800" src="/assets/icons/feather/chevron-right.svg">
    </button>
  </div>

  <div class="p-4 bg-neutral-100 rounded-3xl hidden mt-2 sm:flex-1 sm:flex sm:items-center">

    @if (data.length) {
      <p [class.hidden]="loading"
         class="cd-text-lg text-gray-700 mr-auto">
        Mostrando <span class="font-medium">{{ initialItemIndex + 1 }}</span> a <span
        class="font-medium">{{ initialItemIndex + data.length }}</span> de <span
        class="font-medium">{{ total }}</span> resultados
      </p>
    }

    @if (pages > 1) {
      <nav class="relative z-0 inline-flex ml-auto">

        <button (click)="prevPage()"
                [class.opacity-50]="currentPage === 1"
                [disabled]="currentPage === 1"
                class="btn btn-neutral-outline w-[2.25rem] aspect-square inline-flex items-center justify-center mr-[2.5rem]"
                style="padding: 0 !important;">
          <img alt="chevron-left" class="filter-neutral-800" src="/assets/icons/feather/chevron-left.svg">
        </button>

        @for (index of initialSequence; track index) {
          <button
            (click)="goToPage(index)"
            [class.btn-neutral-outline]="currentPage === index"
            class="btn cd-text-md w-[2.5rem] aspect-square cursor-pointer text-neutral-800">
            {{ index }}
          </button>
        }

        @if (leftDots) {
          <span
            class="cd-text-md w-[2.5rem] aspect-square cursor-pointer text-neutral-800"
            style="letter-spacing: 2px;">
                  &#xb7;&#xb7;&#xb7;
                </span>
        }

        @for (index of middleSequence; track index) {
          <button
            (click)="goToPage(index)"
            [class.btn-neutral-outline]="currentPage === index"
            class="btn cd-text-md w-[2.5rem] aspect-square cursor-pointer text-neutral-800">
            {{ index }}
          </button>
        }

        @if (rightDots) {
          <span
            class="cd-text-md  w-[2.5rem] aspect-square cursor-pointer  text-neutral-800"
            style="letter-spacing: 2px;">
                  &#xb7;&#xb7;&#xb7;
                </span>
        }

        @for (index of finalSequence; track index) {
          <button
            (click)="goToPage(index)"
            [class.btn-neutral-outline]="currentPage === index"
            class="btn cd-text-md w-[2.5rem] aspect-square cursor-pointer text-neutral-800">
            {{ index }}
          </button>
        }

        <button (click)="nextPage()"
                [class.opacity-50]="currentPage === pages"
                [disabled]="currentPage === pages"
                class="btn btn-neutral-outline w-[2.25rem] aspect-square inline-flex items-center justify-center ml-[2.5rem]"
                style="padding: 0 !important;">
          <img alt="chevron-left" class="filter-neutral-800" src="/assets/icons/feather/chevron-right.svg">
        </button>
      </nav>
    }
  </div>
}
